<div class="control-section">
	<div class="loading-shade" *ngIf="isLoading">
		<mat-spinner></mat-spinner>
	</div>
	<div>
		<div id="default_title_bar" class="e-de-ctn-title row" *ngIf="!isMobile">
			<div class="action-left col-2">
				<button class="btn-cancel btn-custom" mat-button (click)="cancel()">Cancel</button>
			</div>
			<div class="center col-6">
				{{ this.name }}
			</div>
			<div class="col-4">
				<div class="action-right">
					<button class="save-to-pdf-btn btn-ru" (click)="saveDocAsPdf()">Save as PDF</button>
					<button class="save-btn btn-ru" (click)="save()">Save</button>
				</div>
			</div>
		</div>
		<div id="default_title_bar" class="e-de-ctn-title row header-excel" *ngIf="isMobile">
			<div class="action-left btn-cancel col-2">
				<button class="cancel-button button-action" (click)="cancel()">
					<mat-icon>chevron_left</mat-icon>
				</button>
			</div>
			<div class="center col-8 document-detail-title-mobile">Document Details</div>
			<div class="col-2 action-right btn-more">
				<button class="more-option button-action" (click)="openSaveDocument()">
					<mat-icon>more_horiz</mat-icon>
				</button>
			</div>
		</div>
		<div>
			<ejs-documenteditorcontainer
				#documenteditor
				[enableToolbar]="true"
				[locale]="culture"
				(created)="onCreate()"
				(contentChange)="onDocumentChange()"
				style="display: block"
				[ngClass]="isMobile ? 'documenteditor-mobile' : 'documenteditor'"
			>
			</ejs-documenteditorcontainer>
		</div>
	</div>
</div>
